import type { App } from "@/models";
import { get as apiGet } from "./API";

export function locations(): Promise<App[]> {
  return apiGet("company/locations");
}
